import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12.5 21q -1.82 0 -5.458 .005a1.98 1.98 0 0 1 -1.881 -1.367l-3.064 -9.43a1.98 1.98 0 0 1 .719 -2.212l8.021 -5.828a1.98 1.98 0 0 1 2.326 0l8.021 5.828c.694 .504 .984 1.397 .719 2.212l-1.559 4.792","key":"svg-0"}],["path",{"d":"M16 19h6","key":"svg-1"}]]

const IconPentagonMinus = createReactComponent('outline', 'pentagon-minus', 'PentagonMinus', __iconNode);

export default IconPentagonMinus;